import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

export type StoreCustomerManagementCustomerDetail = {
    countryCode: string;
    firstName: string;
    lastName: string;
    createDate: string;
    updateDate: string | null;
};

export type StoreCustomerManagementCustomerPhone = {
    phone: string;
    countryCode: string;
    phoneCountryCode: string | null;
    isValid: boolean;
    createDate: string;
    validDate: string | null;
    updateDate: string | null;
};

export type StoreCustomerManagementPreference = {
    countryCode: string;
    isEmailOptin: boolean;
    isSmsOptin: boolean;
    isCallOptin: boolean;
    createDate: string;
    updateDate: string | null;
};

export type StoreCustomerManagementCustomerLanguage = {
    platform: number;
    countryCode: string;
    languageCode: string;
    createDate: string;
    updateDate: string | null;
};

export type StoreCustomerManagementCustomer = {
    globalCustomerId: string;
    ssoCustomerId: number;
    email: string;
    emailIsValid: boolean;
    platform: number;
    gender: string | null;
    birthDate: string | null;
    createDate: string;
    validDate: string | null;
    updateDate: string | null;
    customerType: string | null;
    customerDetails: StoreCustomerManagementCustomerDetail[];
    customerPhones: StoreCustomerManagementCustomerPhone[];
    preferences: StoreCustomerManagementPreference[];
    customerLanguages: StoreCustomerManagementCustomerLanguage[];
};

export type OptHistoryGridRow = {
    id: number;
    date: string;
    source: string;
    platform: string;
    status: string;
    permissionValue: string;
    ipAddress: string;
    device: string;
};

const searchCustomerByPhone = (params: { phone: string }) =>
    request({
        url: ApiURL.Query.searchCustomerByPhone,
        method: RequestType.GET,
        params,
    });

const searchCustomerBySsoId = (params: { customerId: number }) =>
    request({
        url: ApiURL.Query.searchCustomerBySsoId,
        method: RequestType.GET,
        params,
    });

export const StoreCustomerManagementQuery = {
    searchCustomerByPhone,
    searchCustomerBySsoId,
};
